import { Page } from 'components';
import { UserType } from 'helpers/enums';
import { appUserContext } from 'helpers/services';
import { useContext } from 'react';
import { Filters, Results, Toolbar } from './components';
import { registrationsContext } from './RegistrationsContext';

let Registrations = () => {
    let { currentUser } = useContext(appUserContext);
    let { isLoading } = useContext(registrationsContext);


    return (
        <Page
            useHeader={true}
            title="Registrations"
            isLoading={isLoading}
            addNewUrl={currentUser?.userType === UserType.Videndum ? "/registration/addnew" : undefined}
        >
            <Filters />
            <Toolbar />
            <Results />
        </Page>
    )
}

export default Registrations;